// extracted by mini-css-extract-plugin
export default {"error-text":"Card_error-text__RLpPf","card":"Card_card__Iwcvi","no-shadow":"Card_no-shadow__3FcmV","height-auto":"Card_height-auto__lu+vK"};